<template>
  <BaseNew
    @new-confirm-action="createEntry"
    @new-cancel-action="resetForm"
    @new-open-action="loadServerEntry"
    @clear-form-errors="clearFormErrors"
    ref="baseNew"
    width="50%"
    :formErrors="formErrors"
    :loading="loading"
    :pageLoading="pageLoading"
    :modelNameSingular="modelNameSingular"
    @new-confirm-and-add-other-action="createEntryAndAddOther"
    :saveAndAddOtherButtonEnabled="true"
  >
    <template slot="newForm">
      <Form
        ref="form"
        :entry="entry"
        :extraData="extraData"
        :periodLoss="periodLoss"
        :modelNameSingular="modelNameSingular"
      />
    </template>
  </BaseNew>
</template>

<script>
import gql from 'graphql-tag';
import Form from "./form.vue";
import BaseNew from "@shared_components/base_new.vue";

export default {
  data() {
    return {
      error: null,
      loading: true,
      pageLoading: false,
      entry: null,
      formErrors: [],
      extraData: null,
    };
  },
  props: {
    periodLoss: Object,
    modelNameSingular: String,
  },
  components: {
    Form: Form,
    BaseNew: BaseNew
  },
  methods: {
    loadServerEntry: function() {
      this.loading = true;
      this.$apollo
        .query({
          query: NEW_PERIOD_LOSS_ITEM_QUERY,
          variables: {
            periodId: this.periodLoss.periodId
          },
          fetchPolicy: "no-cache"
        })
        .then(response => {
          // console.log("itens for periodLossItem", response);
          this.entry = response.data.accountContext.periodLossItem;
          this.extraData = response.data;
        })
        .catch(response => console.log(response))
        .finally(() => (this.loading = false));
    },
    createEntry: function() {
      if (this.$refs.form.isFormValid()){
        this.$refs.baseNew.closeDialog();
        this.$emit("entry-created", this.entry);
        this.resetForm();
        return true;
      } else {
        return false;
      }
    },
    createEntryAndAddOther: function() {
      if (this.createEntry()){
        this.loadServerEntry();
        this.$refs.baseNew.newDialog = true;
      }
    },
    resetForm: function() {
      if (this.$refs.form) {
        this.$refs.form.resetFormInputs();
      }
      this.formErrors = [];
    },
    clearFormErrors: function() {
      this.formErrors = [];
    }
  }
};

const NEW_PERIOD_LOSS_ITEM_QUERY = gql `
  query($periodId: ID!) {
    accountContext {
      periodLossItem {
        id
        quantity
        unitId
        unit {
          id
          name
        }
        varietyId
        variety {
          id
          name
        }
        validations
      }
      allVarietiesOfPeriod(periodId: $periodId) {
        id
        name
        title
      }
    }
  }
`;

</script>

<style scoped></style>
